
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { copyToClipboard } from "./utils";

interface BankTransferDialogProps {
  bookingId: string;
  onConfirmPayment: (bookingId: string) => Promise<void>;
  isConfirmingPayment: boolean;
}

export const BankTransferDialog = ({
  bookingId,
  onConfirmPayment,
  isConfirmingPayment,
}: BankTransferDialogProps) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button 
          variant="outline" 
          className="w-[50px] h-[50px] p-0 bg-black text-white border-black hover:bg-black/90 hover:text-white rounded-xl overflow-hidden"
        >
          <img 
            src="/lovable-uploads/2e261ae6-8523-4b19-a971-19702b0d27b2.png" 
            alt="Bank Transfer"
            className="w-full h-full object-contain bg-black"
          />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Bank Transfer Details</DialogTitle>
          <DialogDescription>
            Click on each detail to copy to clipboard
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div 
            onClick={() => copyToClipboard("Fahad Ali", "Name")}
            className="cursor-pointer hover:bg-gray-100 p-2 rounded"
          >
            <p><strong>Name:</strong> Fahad Ali</p>
          </div>
          <div 
            onClick={() => copyToClipboard("AE040410000012056349001", "IBAN")}
            className="cursor-pointer hover:bg-gray-100 p-2 rounded"
          >
            <p><strong>IBAN:</strong> AE040410000012056349001</p>
          </div>
          <div 
            onClick={() => copyToClipboard("0012056349001", "Account Number")}
            className="cursor-pointer hover:bg-gray-100 p-2 rounded"
          >
            <p><strong>Account Number:</strong> 0012056349001</p>
          </div>
          <div 
            onClick={() => copyToClipboard("SIB", "Bank")}
            className="cursor-pointer hover:bg-gray-100 p-2 rounded"
          >
            <p><strong>Bank:</strong> SIB</p>
          </div>
        </div>
        <div className="mt-6 flex justify-center">
          <Button 
            onClick={() => onConfirmPayment(bookingId)}
            disabled={isConfirmingPayment}
            className="bg-green-600 hover:bg-green-700 text-white"
          >
            {isConfirmingPayment ? "Confirming..." : "Confirm Payment"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
